import { AddOutlined } from "@mui/icons-material";
import { Container, Fab } from "@mui/material";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useMicrospecDynamicUIContext } from "../../../MicrospecDynamicUI/GlobalProvider";
import DataTable from "../DataTable/DataTable";
import AddNewUserDialog from "./AddNewUserDialog";

const tableHeadCells = [
  {
    id: "first_name",
    numeric: false,
    disablePadding: false,
    label: "الإسم الأول",
    sortable: true,
  },
  {
    id: "last_name",
    numeric: false,
    disablePadding: false,
    label: "إسم العائلة",
    sortable: true,
  },
  {
    id: "phone",
    numeric: false,
    disablePadding: false,
    label: "هاتف",
    sortable: true,
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: 'بريد إلكتروني',
    sortable: true,
  },
  {
    id: "created_at",
    numeric: false,
    disablePadding: false,
    label: "تاريخ",
    date: true,
    sortable: true,
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "وضع الحساب",
    type: "chip",
    sortable: true,
  },
];

const UsersList = () => {
  const { cloudProvider } = useMicrospecDynamicUIContext();
  const { firestore } = cloudProvider;
  const [users, setUsers] = useState();
  const [isAddNewUserOpen, setAddNewUserOpen] = useState(false);
  const [newUserDetails, setNewUserDetails] = useState();

  const retrieveUsersList = async () => {
    const formRef = collection(firestore.instance, "users");
    const q = query(formRef, orderBy("created_at", "desc"));
    const data = await getDocs(q).then((usersInstances) => {
      if (usersInstances.empty) {
        return [];
      }
      const usersDocsData = usersInstances.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
        status: doc.data().status || "active",
      }));

      return usersDocsData;
    });
    setUsers(data);
  };

  const handleOpenAddNewUser = () => setAddNewUserOpen(true);
  const handleCloseAddNewUser = () => setAddNewUserOpen(false);

  useEffect(() => {
    if (!users) {
      retrieveUsersList();
    }
  }, [users]);

  return (
    <>
      <Container maxWidth="xl">
        <DataTable
          items={users}
          downloadAction={Boolean(true)}
          downlaodedFileName="مستخدمين"
          tableHeader="مستخدمين"
          tableHeadCells={tableHeadCells}
        />
      </Container>
      <Fab
        sx={{
          position: "absolute",
          left: 10,
          bottom: 10,
        }}
        onClick={() => handleOpenAddNewUser()}
        color="secondary"
      >
        <AddOutlined />
      </Fab>
      {Boolean(isAddNewUserOpen) && (
        <AddNewUserDialog
          open={Boolean(isAddNewUserOpen)}
          onClose={handleCloseAddNewUser}
          users={users}
          setUsers={setUsers}
        />
      )}
    </>
  );
};

export default UsersList;
